<script lang="ts">
  import Icon from '$components/ui/icon/icon.svelte';

  import { drawer } from '$lib/stores/drawer';
  import { reducedMotion } from '$lib/stores/reduced-motion';
  import { cn } from '$lib/utils';
  import { fade, scale } from 'svelte/transition';
  import { CART_DRAWER_ID } from '$lib/constants';
  import { cart } from '$lib/cart';
  import AddedToCartToast from './added-to-cart-toast.svelte';
  import { onMount } from 'svelte';
  import { cartId } from '$lib/cart/cart-id';
  import { createBreakpointMediaQueryStore } from '$lib/stores/media';

  $: cartQuantity = $cart?.totalQuantity ?? 0;

  // added to cart toast
  let prevQty: undefined | number;
  let timeout: undefined | NodeJS.Timeout;

  onMount(() => {
    if (!$cartId) {
      // if there's no cart, we will not fetch it.
      // we need to init `prevQty` as 0 so it can trigger the toast when adding the first item.
      prevQty = 0;
    }
  });

  const cartState = cart.state;
  $: if ($cartState?.isSettled) {
    if (prevQty !== cartQuantity) {
      if (prevQty === undefined || prevQty >= cartQuantity || $drawer.id === CART_DRAWER_ID) {
        // - just fetched the cart for the first time
        // - the cart quantity decreased.
        // - the cart is open (qty increased from the drawer)
        // no toast notification needed.
        prevQty = $cart?.totalQuantity ?? 0;
      } else {
        // show notification for a while.
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => (prevQty = cartQuantity), 5000);
      }
    }
  }

  const lg = createBreakpointMediaQueryStore('lg');
</script>

<div class={cn('relative lg:w-auto', cartQuantity ? 'w-8' : 'w-6')}>
  {#if !$drawer.id || $lg || $drawer?.meta?.showCartButtonOnMobile}
    <button
      aria-label="show-cart"
      transition:fade|global={{ duration: $reducedMotion ? 0 : 150 }}
      class={cn(
        'relative h-12 items-center justify-center lg:aspect-square lg:h-fit flex rounded-micro border-none shadow-none outline-none transition-all focus-visible:ring motion-reduce:transition-none',
        $drawer.id === CART_DRAWER_ID && 'invisible opacity-0 lg:visible lg:opacity-100'
      )}
      on:click={() => {
        drawer.open(CART_DRAWER_ID);
      }}
    >
      <Icon size="lg" icon="bag" />
      {#if cartQuantity}
        {#key cartQuantity}
          <div
            transition:scale
            class="absolute top-3 left-[55%] lg:left-3.5 lg:top-0 box-content flex items-center justify-center rounded-xs border-2 border-background bg-accent px-[3.5px] py-[0.5px] text-highlight"
          >
            <span
              class="mb-px block select-none text-xs/none font-semibold lining-nums tabular-nums"
            >
              {cartQuantity}
            </span>
          </div>
        {/key}
      {/if}
    </button>
  {/if}

  {#if prevQty !== undefined && cartQuantity > (prevQty ?? 0)}
    <AddedToCartToast />
  {/if}
</div>
